import { ClassificationsBrowserTreeViewEnum } from '@/common/services/swagger/index.defs';
import { IRouteData } from '../runtime/IRouteData';

export const defaultRoute: IRouteData = {
  view: ClassificationsBrowserTreeViewEnum.Offering,
};
